function formatNumber(num) {
    return parseInt(num).toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
    });
}

export default formatNumber;
